import ProjectManagementJob from './ProjectManagementJob';

export default ProjectManagementJob;
